import { FC } from 'react';
import CommonPage from '../components/page/CommonPage';
import TenantList from '../components/tenant/TenantList';
import { PageTitle } from '../components/common/PageTitle';

const TenantListPage : FC= () => {

    return (
        <CommonPage selectBtnIndex={0}>
            <PageTitle title="テナント一覧" />
            <TenantList />
        </CommonPage>
    )
}

export default TenantListPage;